import axios from "axios";

const defaultState = {
    docData: null,
};


// ======================================================================
// Initial State
// ======================================================================

const state = {
    docData: defaultState.docData
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getDocData: state => state.docData,
}

// ======================================================================
// Actions
// ======================================================================

const actions = {

    loadDocData({commit, rootGetters}, data) {
        let promise = new Promise((resolve, reject) => {

            const config = {
                method: 'get',
                url: data.url,
            }
            if (data.url) {
                let axiosRequest = axios(config);

                axiosRequest.then((response) => {
                    commit('setDocData', {
                        title: data.title,
                        content: response.data,
                    });
                    resolve();
                });


                axiosRequest.catch(err => {
                    console.log("Error getting doc data", err);
                    commit('setDocData', null);
                    reject(err);
                })
            }

        })

        return promise;
    }
};

// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setDocData (state, newValue) {
      state.docData = newValue;
    },
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/DocStore.js